import { render, staticRenderFns } from "./CommonSuccesPay.vue?vue&type=template&id=31f088ae&scoped=true&"
import script from "./CommonSuccesPay.vue?vue&type=script&lang=js&"
export * from "./CommonSuccesPay.vue?vue&type=script&lang=js&"
import style0 from "./CommonSuccesPay.vue?vue&type=style&index=0&id=31f088ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f088ae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VImg,VRow})
